import React, { useState } from "react";
import { User, MapPin } from "lucide-react";
import HEventTypeToggle from "./HEventTypeToggle";
import HTitleInput from "./HTitleInput";
import HTimeSection from "./HTimeSection";
import HActionButton from "./HActionButton";
import HUserSection from "./HUserSection";
import HFormModal from "./HFormModal";
import logger from "../utils/logger";


const HCreateEventModal = ({ isOpen, onClose, initialType = "event" }) => {
  // Convert "announcement" to "post" if it's passed as initialType
  const normalizedInitialType = initialType === "announcement" ? "post" : initialType;

  const [eventType, setEventType] = useState(normalizedInitialType);
  const [title, setTitle] = useState("");

  const handleSave = () => {
    logger.log(`${eventType === "event" ? "Event" : "Post"} saved:`, {
      eventType,
      title,
    });
    // save logic here
    onClose();
  };

  const modalTitle = eventType === "post" ? "Create a Post" : "Create an Event";
  const primaryActionLabel = eventType === "post" ? "Create Post" : "Save";

  return (
    <HFormModal
      isOpen={isOpen}
      onClose={onClose}
      title={modalTitle}
      primaryActionLabel={primaryActionLabel}
      secondaryActionLabel="Cancel"
      onPrimaryAction={handleSave}
    >
      <HEventTypeToggle activeType={eventType} onTypeChange={setEventType} />

      <HTitleInput value={title} onChange={setTitle} />

      <HTimeSection />

      <div className="flex gap-3">
        <HActionButton label="Add People" icon={<User className="w-4 h-4" />} variant="primary" fullWidth />
        <HActionButton label="Add location" icon={<MapPin className="w-4 h-4" />} variant="outline" fullWidth />
      </div>

      <HUserSection />
    </HFormModal>
  );
};

export default HCreateEventModal;
